import { contents } from "./content";

export const CARD_ENTERANCE_DURATION = 1;
export const DELAY_PER_CONTENT_CARD = 0.5;
export const CASINO_IMAGE_ENTERANCE_DURATION = 1;
export const CASINO_IMAGE_ENTERANCE_DELAY =
    DELAY_PER_CONTENT_CARD * contents.length;
